/*
  Lisen – ensartede Findify-produktkort (tilføjet af Claude, sep. 2026)

  Findify tegner produktkortene selv (React), så vi ændrer ikke deres markup.
  I stedet læser vi titlen, skjuler den med CSS og indsætter vores egen blok:
    .lisen-fcard__name
      .lisen-fcard__titelraekke
        .lisen-fcard__title  – kort navn (uden varenumre og uden længden)
        .lisen-card__laengder – længderne, i samme linje som navnet
      .lisen-fcard__brand    – produktets vendor fra Shopify

  Rækkefølge på kortet: størrelser / navn + længder / brand / pris / farver.
  Kortet får desuden Wishlist Kings favorit-hjerte i billedets øverste højre
  hjørne og badges nederst på billedet: serieord og pasform.

  Brand, farveprikker, længder og badges hentes færdigtegnede fra
  /products/<handle>?view=lisen-vendor (templates/product.lisen-vendor.liquid),
  som bruger de samme snippets som temaets egne kort – så logikken kun findes
  ét sted. Svaret gemmes i sessionStorage, så hver vare kun hentes én gang.
  Findify tegner kortene om, når der filtreres og sorteres, så prikkerne
  sættes ind igen, hver gang kortene er blevet rørt.
  Styling: assets/lisen-product-styling.css og assets/lisen-kort-hurtigkoeb.css.

  Bemærk om CACHE_KEY: den skal tælles op, hver gang formatet eller markuppen
  på de gemte data ændrer sig. Ellers læser en tilbagevendende kunde den
  gamle form. v2 → v3 da pasformen kom til, v3 → v4 da badges blev stablet,
  v4 → v5 da tilbudsbadgen kom til, v6 → v7 da varer med én størrelse
  får brikken valgt på forhånd.

  Filtrene på kollektionssiderne ligger bag en "Filtrer"-knap, der indsættes
  til venstre for "Sortér efter". Knappen viser antallet af valgte filtre, og
  panelet lukker ved klik udenfor eller Esc. Den hører til desktop – på mobil
  har Findify sin egen drawer.

  KØB FRA KORTET – samme panel, to steder:

  1. Desktop: panelet ligger i billedet og kommer frem ved hover.
  2. Mobil: hover findes ikke, så kortet får en lille kurv-knap nederst til
     højre på billedet. Et tryk åbner det samme panel som et ark, der glider
     op fra bunden af skærmen – i fuld bredde, så størrelserne er til at
     ramme, og med varens billede, navn og pris øverst, så man kan se hvad
     man køber. Indholdet bygges af den samme fillQuickAdd() som på desktop.

  Størrelser, farve og længde (fra varenummeret) og forsalgsstatus hentes fra
  /products/<handle>?view=lisen-card, som kører præcis samme beregning som
  produktsiden (snippets/lisen-forsalg-data.liquid).
  Er den valgte størrelse på forsalg, hedder knappen "Forudbestil nu".
  Samme regel styrer knappen i "Style sammen med" på produktsiden.

  Begge steder sendes linjeegenskaben "Forventet levering" med i kurven –
  samme felt og samme tekster som produktsiden (snippets/forsalg-besked.liquid),
  så leveringen står på varen i kurv, checkout og ordrebekræftelse.
*/
(function () {
  'use strict';

  var CARD = '.findify-components--cards--product';
  var TITLE = '.findify-components--cards--product__title';
  var CONTENT = '.findify-components--cards--product__content';
  // Kollektionssider uden Findify bruger temaets egne kort. De får samme
  // hurtigkøb – resten af kortet (navn, brand, mærker) styrer temaet selv.
  var TEMA_KORT = '.grid-product__content';
  var TEMA_BILLEDE = '.grid-product__image-mask';
  var ALLE_KORT = CARD + ', ' + TEMA_KORT;
  var BILLEDE = '.findify-components--cards--product__image, ' + TEMA_BILLEDE;
  var CACHE_KEY = 'lisen-kort-v8';
  var MAX_PARALLEL = 6;

  // Hover findes ikke på en touchskærm, så der bruges arket i stedet
  var TOUCH = !!(window.matchMedia && window.matchMedia('(hover: none), (pointer: coarse)').matches);

  /* ---------- Kortdata: brand, farver, længder og badges ---------- */

  var cache = {};
  try { cache = JSON.parse(sessionStorage.getItem(CACHE_KEY)) || {}; } catch (e) { cache = {}; }

  function saveCache() {
    try { sessionStorage.setItem(CACHE_KEY, JSON.stringify(cache)); } catch (e) {}
  }

  var pending = {};   // handle -> [callbacks]
  var queue = [];
  var active = 0;

  function pump() {
    while (active < MAX_PARALLEL && queue.length) {
      fetchVendor(queue.shift());
    }
  }

  function fetchVendor(handle) {
    active++;
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + 'products/' + encodeURIComponent(handle) + '?view=lisen-vendor', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        var svar = {};
        try { svar = JSON.parse(text) || {}; } catch (e) { svar = {}; }
        var data = {
          v: svar.vendor || '',
          f: svar.farver || '',
          l: svar.laengder || '',
          p: svar.pasform || ''
        };
        cache[handle] = data;
        saveCache();
        return data;
      })
      .catch(function () { return { v: '', f: '', l: '', p: '' }; })
      .then(function (data) {
        active--;
        var cbs = pending[handle] || [];
        delete pending[handle];
        for (var i = 0; i < cbs.length; i++) cbs[i](data);
        pump();
      });
  }

  function getVendor(handle, cb) {
    if (Object.prototype.hasOwnProperty.call(cache, handle)) { cb(cache[handle]); return; }
    if (pending[handle]) { pending[handle].push(cb); return; }
    pending[handle] = [cb];
    queue.push(handle);
    pump();
  }

  /* ---------- Findifys varedata ---------- */

  function itemOf(card) {
    try {
      var k = Object.keys(card).filter(function (x) { return /^__reactFiber/.test(x); })[0];
      var f = k && card[k];
      for (var d = 0; f && d < 20; d++, f = f.return) {
        var p = f.memoizedProps;
        if (p && p.item) return p.item;
      }
    } catch (e) {}
    return null;
  }

  function handleOf(card) {
    var item = itemOf(card);
    var url = item ? (item.get ? item.get('product_url') : item.product_url) : '';
    if (!url) {
      var a = card.querySelector('a[href*="/products/"]');
      url = a ? a.getAttribute('href') : '';
    }
    var m = String(url || '').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : '';
  }

  /* ---------- Favorit-hjerte (Wishlist King) ---------- */

  function productId(card) {
    var item = itemOf(card);
    if (!item) return '';
    var id = item.get ? item.get('id') : item.id;
    return id ? String(id) : '';
  }

  function addWishlistButton(card) {
    var WK = window.WishlistKing;
    if (!WK || !WK.createComponent) return false;
    if (card.querySelector('.wk-button--floating')) return true;
    var img = card.querySelector('.findify-components--cards--product__image');
    var id = productId(card);
    if (!img || !id) return true;
    try {
      img.appendChild(WK.createComponent('wishlist-button-floating', { id: id }));
    } catch (e) {}
    return true;
  }

  /* ---------- Kort ---------- */

  // Varenumre og længden til sidst ("30'") hører ikke til navnet på kortet –
  // længderne står som knapper ved siden af navnet
  function shortName(title) {
    var first = title.split(' | ')[0].trim();
    return first.split(' ').filter(function (w) {
      if (/^\d{4,}$/.test(w)) return false;
      if (/^\d{2}['’]$/.test(w)) return false;
      return true;
    }).join(' ') || first;
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    e.className = cls;
    if (text) e.textContent = text;
    return e;
  }

  // Farveprikker og længder kommer færdigtegnede fra temaet, så de ser ud
  // præcis som på de kollektionssider, Findify ikke styrer
  function tilfoejEkstra(content, data) {
    if (!content || !data) return;
    if (data.f && !content.querySelector('.lisen-card__farver')) {
      var a = document.createElement('div');
      a.innerHTML = data.f;
      while (a.firstChild) content.appendChild(a.firstChild);
    }
    if (data.l && !content.querySelector('.lisen-card__laengder')) {
      var b = document.createElement('div');
      b.innerHTML = data.l;
      var maal = content.querySelector('.lisen-fcard__titelraekke') || content;
      while (b.firstChild) maal.appendChild(b.firstChild);
    }
  }

  // Badgesene hører til billedet, ikke til tekstblokken. Temaets egne kort
  // har dem allerede fra Liquid, så der sker ingenting to gange.
  function tilfoejPasform(card, data) {
    if (!card || !data || !data.p) return;
    var img = card.querySelector(BILLEDE);
    if (!img || img.querySelector('.lisen-kortbadges')) return;
    var boks = document.createElement('div');
    boks.innerHTML = data.p;
    while (boks.firstChild) img.appendChild(boks.firstChild);
  }

  function enhance(card) {
    var h = card.querySelector(TITLE);
    var content = card.querySelector(CONTENT);
    if (!h || !content) return;
    var title = (h.textContent || '').trim();
    if (!title) return;
    var handle = handleOf(card);

    // Kortet er sat op i forvejen. Findify kan have tegnet indholdet om
    // undervejs, så farver, længder og badges sættes ind igen, hvis de mangler.
    if (card.getAttribute('data-lisen-title') === title) {
      if (handle && Object.prototype.hasOwnProperty.call(cache, handle)) {
        tilfoejEkstra(content, cache[handle]);
        tilfoejPasform(card, cache[handle]);
      }
      return;
    }

    var old = content.querySelectorAll('.lisen-fcard__name');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);

    var nameBox = el('div', 'lisen-fcard__name');
    var titelRaekke = el('div', 'lisen-fcard__titelraekke');
    var titel = el('div', 'lisen-fcard__title', shortName(title));
    titel.setAttribute('aria-hidden', 'true');
    titelRaekke.appendChild(titel);
    nameBox.appendChild(titelRaekke);
    var brand = el('div', 'lisen-fcard__brand');
    nameBox.appendChild(brand);
    content.insertBefore(nameBox, h);

    card.setAttribute('data-lisen-title', title);
    card.classList.add('lisen-fcard');

    if (!addWishlistButton(card)) wkPending = true;

    if (handle) {
      getVendor(handle, function (data) {
        if (card.getAttribute('data-lisen-title') !== title) return;
        brand.textContent = (data && data.v) || '';
        tilfoejEkstra(card.querySelector(CONTENT) || content, data);
        tilfoejPasform(card, data);
      });
    }
  }

  /* ---------- Filtre bag en "Filtrer"-knap ---------- */

  var F_ROOT = '.findify-layouts--search';
  var F_SLOT = '.findify-components-search--desktop-actions__block-inner';
  var F_FACETS = '.findify-components-search--desktop-facets__horizontal';
  var F_OPEN = 'lisen-filters-open';
  var F_ICON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" ' +
    'stroke-linecap="round" aria-hidden="true"><path d="M4 7h10M18 7h2M4 17h4M12 17h8"/>' +
    '<circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/></svg>';

  function filterRoot() { return document.querySelector(F_ROOT); }

  function closeFilters() {
    var root = filterRoot();
    if (!root) return;
    root.classList.remove(F_OPEN);
    var btn = root.querySelector('.lisen-filter-toggle');
    if (btn) btn.setAttribute('aria-expanded', 'false');
  }

  // Antal valgte filtre vises på knappen
  function updateFilterCount(root, btn) {
    var n = root.querySelectorAll(F_FACETS + ' button[role="checkbox"][aria-checked="true"]').length;
    var badge = btn.querySelector('.lisen-filter-toggle__count');
    if (!badge) return;
    if (n > 0) {
      badge.textContent = n;
      badge.removeAttribute('hidden');
    } else {
      badge.textContent = '';
      badge.setAttribute('hidden', '');
    }
  }

  function setupFilters() {
    var root = filterRoot();
    var slot = document.querySelector(F_SLOT);
    if (!root || !slot || !document.querySelector(F_FACETS)) return;

    var btn = root.querySelector('.lisen-filter-toggle');
    if (!btn) {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'lisen-filter-toggle';
      btn.setAttribute('aria-expanded', 'false');
      btn.innerHTML = F_ICON +
        '<span class="lisen-filter-toggle__label">Filtrer</span>' +
        '<span class="lisen-filter-toggle__count" hidden></span>';
      btn.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = root.classList.toggle(F_OPEN);
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
      slot.appendChild(btn);
    } else if (btn.parentNode !== slot) {
      slot.appendChild(btn);
    }
    updateFilterCount(root, btn);
  }

  document.addEventListener('click', function (e) {
    var root = filterRoot();
    if (!root || !root.classList.contains(F_OPEN)) return;
    if (e.target.closest && e.target.closest('.lisen-filter-toggle')) return;
    var facets = root.querySelector(F_FACETS);
    if (facets && facets.contains(e.target)) return;
    closeFilters();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.keyCode === 27) { closeFilters(); lukArk(); }
  });

  /* ---------- "Style sammen med" på produktsiden ---------- */

  // Kortene bruger den samme vælger som hurtigkøb på kollektionskortene,
  // så farve, størrelser, knaptekst og levering er ens de to steder.
  function setupStyleWith() {
    var bokse = document.querySelectorAll('[data-lisen-stylewith-buy]:not([data-lisen-ready])');
    for (var i = 0; i < bokse.length; i++) {
      var box = bokse[i];
      box.setAttribute('data-lisen-ready', '');
      var handle = box.getAttribute('data-lisen-stylewith-buy');
      if (!handle) continue;
      (function (b) {
        productData(handle).then(function (data) { fillQuickAdd(b, data); });
      })(box);
    }

    var WK = window.WishlistKing;
    var hearts = document.querySelectorAll('.lisen-stylewith__wk[data-lisen-wk]');
    if (!hearts.length) return;
    if (!WK || !WK.createComponent) { wkPending = true; return; }
    for (var j = 0; j < hearts.length; j++) {
      var hjerte = hearts[j];
      if (hjerte.querySelector('.wk-button')) continue;
      try {
        hjerte.appendChild(WK.createComponent('wishlist-button-floating', { id: hjerte.getAttribute('data-lisen-wk') }));
      } catch (e) {}
    }
  }

  /* ---------- Hurtigkøb på kollektionskortene ---------- */

  var QA_CACHE = {};
  var MAANEDER = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli',
    'august', 'september', 'oktober', 'november', 'december'];

  // Samme data som produktsiden: templates/product.lisen-card.liquid kalder
  // snippets/lisen-forsalg-data.liquid, så status pr. størrelse er identisk
  function productData(handle) {
    if (!QA_CACHE[handle]) {
      QA_CACHE[handle] = fetch('/products/' + encodeURIComponent(handle) + '?view=lisen-card', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return QA_CACHE[handle];
  }

  function statusOf(data, variantId) {
    return (data && data.status && data.status[String(variantId)]) || null;
  }

  function erForsalg(st) {
    return !!(st && st.status === 'forudbestilling');
  }

  // Ugenummer efter ISO 8601, som på produktsiden
  function ugenummer(d) {
    var t = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    var dag = t.getUTCDay() || 7;
    t.setUTCDate(t.getUTCDate() + 4 - dag);
    var aarStart = new Date(Date.UTC(t.getUTCFullYear(), 0, 1));
    return Math.ceil(((t - aarStart) / 86400000 + 1) / 7);
  }

  function tilDato(iso) {
    var p = String(iso || '').split('-');
    var d = new Date(+p[0], +p[1] - 1, +p[2]);
    return isNaN(d) ? null : d;
  }

  function forsalgTekst(st) {
    if (!erForsalg(st)) return '';
    var d = tilDato(st.dato);
    if (!d) return '';
    var maaned = MAANEDER[d.getMonth()];
    return 'Kommer på lager ' + maaned.charAt(0).toUpperCase() + maaned.slice(1) +
      ' (Uge ' + ugenummer(d) + ')';
  }

  // Samme linjeegenskab som produktsiden sætter (properties[Forventet levering]),
  // så leveringsoplysningen står i kurven, checkout og ordrebekræftelsen.
  // Teksterne skal matche snippets/forsalg-besked.liquid ord for ord.
  var EGENSKAB = 'Forventet levering';

  function leveringsEgenskab(st) {
    if (!st) return '';
    if (st.status === 'eksternt') return '2-5 hverdage';
    if (st.status === 'fjernlager') return 'Fjernlager – 2-5 dages ekstra levering';
    if (st.status === 'forudbestilling') {
      var d = tilDato(st.dato);
      if (!d) return '';
      return 'Forudbestilling – forventet på lager i ' + MAANEDER[d.getMonth()] +
        ' (uge ' + ugenummer(d) + ')';
    }
    return '';
  }

  function sizeLabel(title) {
    var t = String(title || '');
    if (/^(default title|title)$/i.test(t)) return 'Onesize';
    return t
      .replace('XX-Small', 'XXS')
      .replace('X-Small', 'XS')
      .replace('XX-Large', 'XXL')
      .replace('X-Large', 'XL')
      .replace('Small', 'S')
      .replace('Medium', 'M')
      .replace('Large', 'L');
  }

  // Farven står i parentesen i varenummeret, fx "2785 (Black) OS".
  // Leverandørernes farvekoder ryger ud ("Moro556" -> "Moro",
  // "Grigio004/Beige001" -> "Grigio/Beige"), og skrivemåden ensrettes til
  // Stort Forbogstav, fordi SKU'erne svinger mellem BLACK og Peach beige.
  function farveAf(data) {
    var v = (data.variants || []).filter(function (x) {
      return /\(([^)]+)\)/.test(String(x.sku || ''));
    })[0];
    if (!v) return '';
    var navn = String(v.sku).match(/\(([^)]+)\)/)[1].trim();
    var rent = navn
      .replace(/\d+/g, '')
      .replace(/\s*([/-])\s*/g, '$1')
      .replace(/\s{2,}/g, ' ')
      .replace(/^[\s/-]+|[\s/-]+$/g, '')
      .trim();
    if (rent) navn = rent;   // var farven bare et tal, beholdes den som den er
    return navn.toLowerCase().replace(/(^|[\s/-])([a-zæøå])/g, function (hel, foran, bogstav) {
      return foran + bogstav.toUpperCase();
    });
  }

  // Længden er tredje del af varenummeret før parentesen:
  // "181000 401 32 (Dark Blue) 26" -> 32. Har varen ingen længde, er den tom.
  function laengdeAf(data) {
    var v = (data.variants || [])[0];
    if (!v || !v.sku) return '';
    var dele = String(v.sku).split('(')[0].trim().split(/\s+/);
    var l = dele[2] || '';
    return /^\d{2}$/.test(l) ? l : '';
  }

  function quickAddToCart(box, variantId, egenskab) {
    var btn = box.querySelector('.lisen-quickadd__btn');
    if (btn) { btn.disabled = true; btn.textContent = 'Lægger i kurv …'; }
    var krop = { id: variantId, quantity: 1 };
    if (egenskab) {
      krop.properties = {};
      krop.properties[EGENSKAB] = egenskab;
    }
    fetch('/cart/add.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(krop)
    })
      .then(function (r) {
        if (!r.ok) throw new Error('cart');
        return r.json();
      })
      .then(function () {
        if (btn) { btn.textContent = 'Lagt i kurven'; btn.disabled = false; }
        // Kom købet fra arket på mobil, lukker det sig selv bagefter
        if (box.closest && box.closest('.lisen-ark')) setTimeout(lukArk, 700);
        if (window.jQuery) window.jQuery('body').trigger('added.ajaxProduct');
        else window.location.href = '/cart';
      })
      .catch(function () {
        if (btn) { btn.textContent = 'Prøv igen'; btn.disabled = false; }
      });
  }

  function fillQuickAdd(box, data) {
    var sizes = box.querySelector('.lisen-quickadd__sizes');
    var btn = box.querySelector('.lisen-quickadd__btn');
    var info = box.querySelector('.lisen-quickadd__info');
    var farve = box.querySelector('.lisen-quickadd__color');
    if (!data || !data.variants || !data.variants.length) {
      if (box.parentNode) box.parentNode.removeChild(box);
      return;
    }

    // Øverste linje: farve og – på jeans – længden ved siden af
    if (farve) {
      var navn = farveAf(data);
      var laengde = laengdeAf(data);
      var linje = navn ? 'Farve: ' + navn : '';
      if (laengde) {
        linje += (linje ? '   ·   ' : '') + 'Længde: ' + laengde + "'";
      }
      if (linje) farve.textContent = linje;
    }

    var single = data.variants.length === 1;
    var selected = null;
    var egenskab = '';

    // Knaptekst og leveringsbesked pr. størrelse – samme status som produktsiden
    var choose = function (variant, el) {
      selected = variant;
      var all = sizes.querySelectorAll('.lisen-quickadd__size');
      for (var i = 0; i < all.length; i++) all[i].classList.remove('is-selected');
      if (el) el.classList.add('is-selected');
      var st = statusOf(data, variant.id);
      egenskab = leveringsEgenskab(st);
      btn.disabled = false;
      btn.textContent = erForsalg(st) ? 'Forudbestil nu' : 'Læg i kurv';
      if (info) info.textContent = forsalgTekst(st);
    };

    // Varer uden størrelser får én brik (Onesize), der vælges på samme måde
    if (single) box.classList.add('lisen-quickadd--single');
    else box.classList.remove('lisen-quickadd--single');

    data.variants.forEach(function (v) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'lisen-quickadd__size';
      b.textContent = sizeLabel(v.title);
      if (!v.available) {
        b.disabled = true;
        b.title = 'Udsolgt';
      } else {
        b.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          choose(v, b);
        });
      }
      sizes.appendChild(b);
    });

    // Er der præcis én størrelse at vælge imellem (typisk ONESIZE), er valget
    // truffet på forhånd: brikken vælges med det samme, så knappen viser sin
    // rigtige tekst ("Læg i kurv" / "Forudbestil nu") i stedet for "Vælg
    // størrelse". Brikken bliver stående, så man kan se, hvad man køber, men
    // får klassen "er-eneste", så den ikke ser sort/markeret ud – der er jo
    // ikke noget at vælge imellem. Varer med to eller flere størrelser er urørt.
    var brikker = sizes.querySelectorAll('.lisen-quickadd__size');
    if (single && brikker.length === 1 && !brikker[0].disabled) {
      brikker[0].classList.add('er-eneste');
      choose(data.variants[0], brikker[0]);
    }

    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (selected) quickAddToCart(box, selected.id, egenskab);
    });
  }

  function buildQuickAdd(card) {
    // Findify gentegner kortene; er panelet forsvundet, bygges det igen
    if (card.getAttribute('data-lisen-qa') && card.querySelector('.lisen-quickadd')) return;
    var img = card.querySelector(BILLEDE);
    var handle = handleOf(card);
    if (!img || !handle) return;
    card.setAttribute('data-lisen-qa', '1');

    var box = document.createElement('div');
    box.className = 'lisen-quickadd';
    box.innerHTML =
      '<div class="lisen-quickadd__color"></div>' +
      '<div class="lisen-quickadd__sizes"></div>' +
      '<button type="button" class="lisen-quickadd__btn" disabled>Vælg størrelse</button>' +
      '<div class="lisen-quickadd__info"></div>';
    // Klik i panelet må ikke åbne produktsiden
    box.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); });
    img.appendChild(box);

    productData(handle).then(function (p) { fillQuickAdd(box, p); });
  }

  // På desktop bygges panelet først, når musen er over kortet
  document.addEventListener('mouseover', function (e) {
    if (TOUCH || !e.target.closest) return;
    var card = e.target.closest(ALLE_KORT);
    if (card) buildQuickAdd(card);
  });

  /* ---------- Mobil: kurv-knap på kortet åbner panelet som et ark ---------- */

  var KURV_IKON = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" ' +
    'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">' +
    '<path d="M6 7h12l-1 12H7L6 7z"/><path d="M9 7V5.5a3 3 0 0 1 6 0V7"/></svg>';

  var ark = null;

  function byggArk() {
    if (ark) return ark;
    ark = document.createElement('div');
    ark.className = 'lisen-ark';
    ark.setAttribute('hidden', '');
    ark.innerHTML =
      '<div class="lisen-ark__baggrund"></div>' +
      '<div class="lisen-ark__panel" role="dialog" aria-modal="true" aria-label="Læg i kurv">' +
        '<button type="button" class="lisen-ark__luk" aria-label="Luk">&times;</button>' +
        '<div class="lisen-ark__vare">' +
          '<img class="lisen-ark__billede" alt="">' +
          '<div class="lisen-ark__tekst">' +
            '<div class="lisen-ark__navn"></div>' +
            '<div class="lisen-ark__pris"></div>' +
          '</div>' +
        '</div>' +
        '<div class="lisen-ark__indhold"></div>' +
      '</div>';
    ark.querySelector('.lisen-ark__baggrund').addEventListener('click', lukArk);
    ark.querySelector('.lisen-ark__luk').addEventListener('click', lukArk);
    document.body.appendChild(ark);
    return ark;
  }

  function lukArk() {
    if (!ark || ark.hasAttribute('hidden')) return;
    ark.setAttribute('hidden', '');
    ark.classList.remove('er-aaben');
    document.documentElement.classList.remove('lisen-ark-aaben');
  }

  function tekstFra(card, vaelgere) {
    for (var i = 0; i < vaelgere.length; i++) {
      var e = card.querySelector(vaelgere[i]);
      if (e && (e.textContent || '').trim()) return e.textContent.trim();
    }
    return '';
  }

  // Prisen står forskellige steder på temaets og Findifys kort. Findes den
  // ikke via klassenavnene, findes det første element på kortet, der ser ud
  // som et beløb – så holder det også, hvis Findify døber sine klasser om.
  function prisFra(card) {
    var kendt = tekstFra(card, [
      '.grid-product__price',
      '.findify-components--cards--product--price__price',
      '.findify-components--cards--product__price'
    ]);
    if (kendt) return kendt.replace(/\s+/g, ' ').trim();
    var alle = card.querySelectorAll('*');
    for (var i = 0; i < alle.length; i++) {
      if (alle[i].children.length) continue;
      var t = (alle[i].textContent || '').trim();
      if (/^\d[\d.,\s]*\s*kr\.?$/i.test(t)) return t;
    }
    return '';
  }

  function aabnArk(card) {
    var handle = handleOf(card);
    if (!handle) return;
    var a = byggArk();

    var billede = card.querySelector('img');
    var img = a.querySelector('.lisen-ark__billede');
    if (billede && (billede.currentSrc || billede.src)) {
      img.src = billede.currentSrc || billede.src;
      img.removeAttribute('hidden');
    } else {
      img.setAttribute('hidden', '');
    }

    a.querySelector('.lisen-ark__navn').textContent =
      tekstFra(card, ['.lisen-fcard__title', '.grid-product__title', TITLE]);
    a.querySelector('.lisen-ark__pris').textContent = prisFra(card);

    var holder = a.querySelector('.lisen-ark__indhold');
    holder.innerHTML =
      '<div class="lisen-quickadd lisen-quickadd--inline">' +
        '<div class="lisen-quickadd__color"></div>' +
        '<div class="lisen-quickadd__sizes"></div>' +
        '<button type="button" class="lisen-quickadd__btn" disabled>Vælg størrelse</button>' +
        '<div class="lisen-quickadd__info"></div>' +
      '</div>';

    a.removeAttribute('hidden');
    // næste frame, så overgangen kan ses
    setTimeout(function () { a.classList.add('er-aaben'); }, 10);
    document.documentElement.classList.add('lisen-ark-aaben');

    productData(handle).then(function (p) {
      fillQuickAdd(holder.querySelector('.lisen-quickadd'), p);
    });
  }

  function tilfoejKoebknap(card) {
    if (!TOUCH) return;
    var img = card.querySelector(BILLEDE);
    if (!img || img.querySelector('.lisen-koebknap')) return;
    if (!handleOf(card)) return;
    var knap = document.createElement('span');
    knap.className = 'lisen-koebknap';
    knap.setAttribute('role', 'button');
    knap.setAttribute('tabindex', '0');
    knap.setAttribute('aria-label', 'Vælg størrelse og læg i kurv');
    knap.innerHTML = KURV_IKON;
    knap.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      aabnArk(card);
    });
    img.appendChild(knap);
  }

  var queued = false;
  var wkPending = false;   // Wishlist King var ikke klar endnu
  function run() {
    queued = false;
    wkPending = false;
    var cards = document.querySelectorAll(CARD);
    for (var i = 0; i < cards.length; i++) enhance(cards[i]);
    if (TOUCH) {
      var alle = document.querySelectorAll(ALLE_KORT);
      for (var j = 0; j < alle.length; j++) tilfoejKoebknap(alle[j]);
    }
    setupFilters();
    setupStyleWith();
    if (wkPending) setTimeout(retryWishlist, 400);
  }

  // Wishlist King indlæses som modul og kan komme efter kortene
  function retryWishlist() {
    var cards = document.querySelectorAll(CARD);
    var missing = false;
    for (var i = 0; i < cards.length; i++) {
      if (!addWishlistButton(cards[i])) missing = true;
    }
    if (!window.WishlistKing || !window.WishlistKing.createComponent) {
      if (document.querySelector('.lisen-stylewith__wk[data-lisen-wk]')) missing = true;
    } else {
      setupStyleWith();
    }
    if (missing) setTimeout(retryWishlist, 400);
  }

  // requestAnimationFrame sættes på pause, når fanen ikke er fremme. Derfor
  // også en timer, så kortene bliver sat op uanset hvad – fx hvis kunden
  // skifter faneblad, mens kollektionen henter. run() nulstiller queued som
  // det første, så den vej, der kommer bagefter, bliver et nulkald.
  function schedule() {
    if (queued) return;
    queued = true;
    var koer = function () { if (queued) run(); };
    if (window.requestAnimationFrame) window.requestAnimationFrame(koer);
    setTimeout(koer, 120);
  }

  function start() {
    run();
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();